/**
 * created by tian ruo jun
 媒体统计页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BseTitle from "../../components/bseTitle/BseTitle";
import {Select, Empty} from 'antd';
import {HEADER_HEIGHT} from '../../../constants'
import {Scrollbars} from "react-custom-scrollbars";
import dy from './image/dy.svg';
import inter from './image/inter.svg';
import news from './image/new.svg';
import wb from './image/wb.svg';
import wechat from './image/wechat.svg';
import other from './image/other.svg';
import {Tabs} from 'antd';
import './style/MediaStatistics.css'
import ReactEcharts from "echarts-for-react";
import moment from "moment";
import {getStoryPublishResult,getWebsiteMedia,getAllMediaStatistics,getMediaStatisticsByMediaCode} from '../../../actions/mediaStatistics'

const {TabPane} = Tabs;

const {Option} = Select;

export default class MediaStatistics extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            // 媒体数据
            chartsData: [
                {
                    title: '新闻网',
                    type:1,
                    num1: 0,
                    num2: 0,
                    data5: [
                       // {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'},
                       // {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                    ],
                    data30: [
                       //  {time: '07-12', count: '45'}, {time: '07-13', count: '34'}, {time: '07-14',count: '56'}, {time: '07-15', count: '65'},{time: '07-16', count: '76'},
                       //  {time: '07-12', count: '45'}, {time: '07-13', count: '34'}, {time: '07-14',count: '56'}, {time: '07-15', count: '65'},{time: '07-16', count: '76'},
                       //  {time: '07-12', count: '45'}, {time: '07-13', count: '34'}, {time: '07-14',count: '56'}, {time: '07-15', count: '65'},{time: '07-16', count: '76'},
                       //  {time: '07-02', count: '45'}, {time: '07-03', count: '34'}, {time: '07-04',count: '56'}, {time: '07-05', count: '65'},{time: '07-06', count: '76'},
                       //  {time: '07-07', count: '45'}, {time: '07-08', count: '34'}, {time: '07-09',count: '56'}, {time: '07-10', count: '65'},{time: '07-11', count: '76'},
                       //  {time: '07-12', count: '45'}, {time: '07-13', count: '34'}, {time: '07-14',count: '56'}, {time: '07-15', count: '65'},{time: '07-16', count: '76'},
                    ]
                },
                {
                    title: '微博',
                    type:3,
                    num1: 0,
                    num2: 0,
                    data5: [
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'},
                       //  {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},{time: '2016-07-16', count: '76'}, {time: '2016-07-15', count: '65'},
                    ],
                    data30: [
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                       //  {time: '2016-07-02', count: '45'}, {time: '2016-07-03', count: '34'}, {time: '2016-07-04',count: '56'}, {time: '2016-07-05', count: '65'},{time: '2016-07-06', count: '76'},
                       //  {time: '2016-07-07', count: '45'}, {time: '2016-07-08', count: '34'}, {time: '2016-07-09',count: '56'}, {time: '2016-07-10', count: '65'},{time: '2016-07-11', count: '76'},
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                    ]
                },
                {
                    title: '微信',
                    type:2,
                    num1: 0,
                    num2: 0,
                    data5: [
                      //   {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'},
                      //   {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},{time: '2016-07-16', count: '76'}, {time: '2016-07-15', count: '65'},
                    ],
                    data30: [
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-02', count: '45'}, {time: '2016-07-03', count: '34'}, {time: '2016-07-04',count: '56'}, {time: '2016-07-05', count: '65'},{time: '2016-07-06', count: '76'},
                      //  {time: '2016-07-07', count: '45'}, {time: '2016-07-08', count: '34'}, {time: '2016-07-09',count: '56'}, {time: '2016-07-10', count: '65'},{time: '2016-07-11', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                    ]
                },
                {
                    title: '抖音',
                    type:5,
                    num1: 0,
                    num2: 0,
                    data5: [
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'},
                       //  {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},{time: '2016-07-16', count: '76'}, {time: '2016-07-15', count: '65'},
                    ],
                    data30: [
                      //   {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //   {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //   {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //   {time: '2016-07-02', count: '45'}, {time: '2016-07-03', count: '34'}, {time: '2016-07-04',count: '56'}, {time: '2016-07-05', count: '65'},{time: '2016-07-06', count: '76'},
                      //   {time: '2016-07-07', count: '45'}, {time: '2016-07-08', count: '34'}, {time: '2016-07-09',count: '56'}, {time: '2016-07-10', count: '65'},{time: '2016-07-11', count: '76'},
                      //   {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                    ]
                },
                {
                    title: '其他',
                    type:6,
                    num1: 0,
                    num2: 0,
                    data5: [
                       //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'},
                       //  {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},{time: '2016-07-16', count: '76'}, {time: '2016-07-15', count: '65'},
                    ],
                    data30: [
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                      //  {time: '2016-07-02', count: '45'}, {time: '2016-07-03', count: '34'}, {time: '2016-07-04',count: '56'}, {time: '2016-07-05', count: '65'},{time: '2016-07-06', count: '76'},
                      //  {time: '2016-07-07', count: '45'}, {time: '2016-07-08', count: '34'}, {time: '2016-07-09',count: '56'}, {time: '2016-07-10', count: '65'},{time: '2016-07-11', count: '76'},
                      //  {time: '2016-07-12', count: '45'}, {time: '2016-07-13', count: '34'}, {time: '2016-07-14',count: '56'}, {time: '2016-07-15', count: '65'},{time: '2016-07-16', count: '76'},
                    ]
                },
            ],
            // 媒体图标及颜色
            styleList:[
                {title:'新闻网',icon:inter,color:'70, 163, 248'},
                {title:'抖音',icon:dy,color:'82, 15, 108'},
                {title:'微博',icon:wb,color:'251, 85, 85'},
                {title:'微信',icon:wechat,color:'40, 196, 69'},
                {title:'其他',icon:other,color:'250, 209, 65'},
            ],
            // 当前选中的媒体
            thisCode:'',
            // 媒体列表
            codeLIst:[],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getMediaList();
        this.getdata();
    }

    // 获取媒体发布统计数据
    getdata = () => {
        let params = {mediaCode:this.state.thisCode};
        // 新闻网数据
        getStoryPublishResult(params, (res)=>{
            if(res) {
                this.formatterByXinWen(res);
            }
        });
        // 其他媒体数据
        getMediaStatisticsByMediaCode(params,(res)=>{
            if(res) {
                this.formatterByOther(res);
            }
        });
    };

    // 新闻网数据处理函数
    formatterByXinWen = (res) => {
        let dataByXinWeb = this.state.chartsData.find(item =>item.title === '新闻网');
        dataByXinWeb.num1 = res.allPublishCount || '';
        dataByXinWeb.num2 = res.todayPublish || '';
        dataByXinWeb.data5 = [];
        dataByXinWeb.data30 = [];
        if(res.week.length && res.weekPublishCount.length) {
            for (let i=0;i<res.week.length;i++) {
                dataByXinWeb.data5.push(
                    {time: res.week[i], count: res.weekPublishCount[i]}
                )
            }
        }
        if(res.month.length && res.monthPublishCount.length) {
            for (let i=0;i<res.month.length;i++) {
                dataByXinWeb.data30.push(
                    {time: res.month[i], count: res.monthPublishCount[i]}
                )
            }
        }
        this.setState({},()=>{
            console.log(this.state.chartsData,'数据更新完毕')
        })
    };

    // 微信微博抖音数据处理函数
    formatterByOther = (res) => {
        for(let i = 1;i<this.state.chartsData.length;i++) {
            let dataByOther = this.state.chartsData[i];
            let type = dataByOther.type;
            dataByOther.num1 = '';
            dataByOther.num2 = '';
            dataByOther.data5 = [];
            dataByOther.data30 = [];
            if(res[type]) {
                dataByOther.num1 = res[type].totalPublishedCount || '';
                dataByOther.num2 = res[type].todayPublishedCount || '';
                res[type].recent7DayData.forEach(item => {
                    dataByOther.data5.push(
                        {time: item._id, count: item.dayCount}
                    )
                });
                res[type].recent30DayData.forEach(item => {
                    dataByOther.data30.push(
                        {time: item._id, count: item.dayCount}
                    )
                });
            }
            this.setState({},()=>{
                console.log(this.state.chartsData,'数据更新完毕')
            })
        }
    };

    // 获取媒体发布下拉列表
    getMediaList = () => {
        getWebsiteMedia({},(res)=>{
            if(res) {
                this.setState({codeLIst:res},()=>{
                    // if(res && res.length && res[0].code) {
                    //     this.handleChange(res[0].code)
                    // }
                })
            }
        })
    };

    // 监听下拉框change事件
    handleChange = (value) => {
        console.log(value);
        if(value === 'all') value = '';
        this.setState({thisCode:value},()=>{
            this.getdata()
        })
    };

    // 右侧主体框架
    render() {
        let optionData = this.state.codeLIst;
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let flowBoxHeight = height - 28 - 60;
        let chartsData = this.state.chartsData;
        let {styleList} = this.state;
        return (
            <div style={{height: height, minWidth: '1200px'}}>
                {/*<BseTitle title={'媒体发布统计'}/>*/}
                <div style={{background:'#fff',height:28}}></div>
                <div style={{background:'#fff',height: '60px', display: 'flex', alignItems: 'center', borderBottom: '1px solid #ababab'}}>
                    <span style={{padding: '20px'}}>媒体名称</span>
                    <Select
                        // defaultValue="all"
                        placeholder={'请选择媒体名称'}
                        style={{width: 186}}
                        onChange={this.handleChange}
                    >
                        <Option key={'all'} value={'all'}>全部媒体</Option>
                        {optionData && optionData.length && optionData.map((item,index)=>(
                            <Option key={index} value={item.code}>{item.name}</Option>
                        ))}
                    </Select>
                </div>
                <Scrollbars style={{height: flowBoxHeight}}>
                    <div style={{padding: '20px'}}>
                        {chartsData && chartsData.length && chartsData.every(item=>!item.num1) ? (
                            <Empty />
                        ) : null}
                        {chartsData && chartsData.length ? (
                            chartsData.map((item, index) => {
                                    if(item.num1) {
                                        return <MyCard key={index} chartsData={item} style={styleList}/>
                                    }
                                }
                            )
                        ) : null}
                    </div>
                </Scrollbars>
            </div>
        )
    }
}

// 卡片
class MyCard extends Component {
    static defaultProps = {
        chartsData: [],
    };
    static propTypes = {
        /**
         *  当前卡片数据
         */
        chartsData: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            flag: '1', // 是否近7日
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    // 近7日/30日切换
    callback = (key) => {
        this.setState({flag: key})
    }

    render() {
        let {style,chartsData} = this.props;
        let myChartsData = this.state.flag === '1' ? chartsData.data5 : chartsData.data30;
        let myStyle = style.find(item=>item.title===chartsData.title);
        let otherStyle = style.find(item=>item.title==='其他');
        let color;
        let icon;
        if(myStyle) {
            color = myStyle.color;
            icon = myStyle.icon;
        } else {
            color = otherStyle.color;
            icon = otherStyle.icon;
        }

        return (
            <div style={{
                height: '340px',
                width: '100%',
                border: '1px solid #ebebeb',
                marginBottom: '20px',
                display: 'flex',
                background: '#fff'
            }}>
                {/*左*/}
                <div style={{flex: 1, borderRight: '1px solid #ebebeb', padding: '20px 10px', boxSizing: 'border-box'}}>
                    <div style={{display: 'flex', alignItems: 'center', fontSize: 30, color: 'rgb('+color+')'}}>
                        <img src={icon} style={{width: '50px', marginRight: '10px'}}/>
                        <div>{chartsData.title}</div>
                    </div>
                    <div style={{marginTop: '20px', paddingLeft: '20px'}}>
                        <div style={{fontSize: 14, color: '#989898'}}>累计发布数</div>
                        <div style={{fontSize: 27, color: '#666666'}}>{chartsData.num1 || 0}</div>
                    </div>
                    <div style={{marginTop: '40px', paddingLeft: '20px'}}>
                        <div style={{fontSize: 14, color: '#989898'}}>今日发布数</div>
                        <div style={{fontSize: 27, color: '#666666'}}>{chartsData.num2 || 0}</div>
                    </div>
                </div>
                {/*右*/}
                <div style={{padding: '20px 40px', flex: 5,display:'flex',flexDirection: 'column'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight:700,
                            color:'#666666',
                        }}>{this.state.flag === '1' ? '近7天发布趋势' : '近30天发布趋势'}</div>
                        <div className={'mediaBox'} style={{marginRight:20}}>
                            <Tabs type="card" defaultActiveKey="1" onChange={this.callback} size={'small'}>
                                <TabPane tab="近7天" key="1">
                                </TabPane>
                                <TabPane tab="近30天" key="0">
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <div style={{flex:1,height:''}}>
                        <MyCharts chartsData={myChartsData} mychartsColor={color} />
                    </div>
                </div>
            </div>
        )
    }
}

// echarts
class MyCharts extends Component {
    static defaultProps = {
        chartsData: [],
    };
    static propTypes = {
        /**
         * 当前echart数据
         */
        chartsData: PropTypes.array.isRequired,
    };

    render() {
        let chartsData = this.props.chartsData;
        let DataX
        if(chartsData.length > 7) {
            DataX = chartsData.map(item => (item.time && moment(item.time).format("MM.DD") || ''));
        } else {
            DataX = chartsData.map(item => (item.time && moment(item.time).format("MM-DD ddd") || ''));
        }
        let DataY = chartsData.map(item => item.count);
        let color = this.props.mychartsColor;
        let option = {
            tooltip: {
                trigger: 'axis',
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: DataX,
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetX:8,
                        shadowColor:'#7f7f7f'
                    },
                    symbol:['none','arrow'],
                    symbolSize:[8, 8],
                    symbolOffset:15
                },
                /* splitLine: {
                         show:true,
                         // 使用深浅的间隔色
                         color: ['#00e2ff']
                 },*/
                axisLabel: {
                    show: true,
                    interval:0,
                    rotate: DataX.length > 15 ? 30 : 0,
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize: 12,
                        padding:10,
                    }
                },
                axisTick:{
                    show:false,
                }

            },

            yAxis: {
                // scale:true,
                // min:'dataMin',
                type: 'value',
                splitNumber:5,
                splitLine: {
                    lineStyle: {
                        // 使用深浅的间隔色
                        color: ['rgba(255,255,255,.1)']
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetY:-8,
                        shadowColor:'#7f7f7f'
                    },
                    symbol:['none','arrow'],
                    symbolSize:[8, 8],
                    symbolOffset:15
                },
                axisLabel: {
                    formatter: (value, index) => {
                        if(value < 1000) return value;
                        const si = [
                            { value: 1, symbol: "" },
                            { value: 1E3, symbol: "K" },
                            { value: 1E6, symbol: "M" },
                            { value: 1E9, symbol: "G" },
                            { value: 1E12, symbol: "T" },
                            { value: 1E15, symbol: "P" },
                            { value: 1E18, symbol: "E" }
                        ];
                        let i;
                        for (i = si.length - 1; i > 0; i--) {
                            if (value >= si[i].value) {
                                break;
                            }
                        }
                        return (value / si[i].value).toFixed(0) + si[i].symbol;
                        // return value.toFixed(3);
                    },
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize:12,
                    }
                },
                axisTick:{
                    show:false,
                },
            },
            series: [
                {
                    name: '发布数',
                    type: 'line',
                    smooth: true,
                    itemStyle: {  /*设置折线颜色*/
                        normal: {
                            color: 'rgba('+ color + ')',
                            width: 2,
                        }
                    },
                    symbolSize:5,
                    lineStyle:{
                        normal: {
                            width:2,
                        },

                    },
                    data: DataY,
                    areaStyle: {
                        opacity:0.3,
                        color: 'rgba('+ color + ')',
                        //     {
                        //     type: 'linear',
                        //     x: 0,
                        //     y: 0,
                        //     x2: 0,
                        //     y2: 1,
                        //     colorStops: [{
                        //         offset: 0, color: 'rgba(29,232,227,.8)',// 0% 处的颜色
                        //     }, {
                        //         offset: 0.5, color: 'rgba(29,232,227,.3)'// 100% 处的颜色
                        //     }, {
                        //         offset: 1, color: 'rgba(29,232,227,.1)'
                        //     }],
                        //     globalCoord: false // 缺省为 false
                        // }
                    },
                }],
            grid: {
                show: true,
                borderColor: 'transparent',
                x:50,
                x2:50,
                y:60,
                y2:40,
            },
        };
        return (
            <ReactEcharts
                option={option}
                notMerge={true}
                lazyUpdate={true}
                style={{width: '100%', height: '100%'}}
            />
        )
    }
}